import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Brand } from 'src/brands/brand';

/** Sends brands without messages (Brand.messagesEnabled) to the dashboard instead. A JWT in the URL has already been picked up by AppComponent on RoutesRecognized, before guards run. */
export const messagesEnabledGuard: CanActivateFn = (route, state) => {
  return Brand.messagesEnabled || inject(Router).createUrlTree(['/dashboard']);
};
